export default __webpack_public_path__ + "static/media/unemployee.5f474bcf.png";